<template>
<Form
	class="m-0 mt-1 mb-3 p-0"
	:class="{
		'px-2': isDesktop,
		'px-0': isMobile,
	}"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ errors, meta: meta, values, setFieldValue }"
	ref="passportForm"
	id="passport-form"
>
	<div :class="{
		'px-0': isDesktop,
		'px-0': isMobile,
	}">
		<div class="row form-row m-0 p-0">
			<div class="form-group col-auto input-min-width">
				<label>{{ Post.settingNames[Post.passportKeys.name] }}</label>
				<Field
					name="name"
					type="text"
					class="form-control form-control-sm"
					:class="{ 'is-invalid': errors.name }"
				/>
				<div class="invalid-feedback">{{errors.name}}</div>
			</div>
		</div>
		<div class="row form-row m-0 p-0">
			<div class="form-group col-auto input-min-width">
				<label>{{ Post.settingNames[Post.passportKeys.shortName] }}</label>
				<Field
					name="short_name"
					type="text"
					class="form-control form-control-sm"
					:class="{ 'is-invalid': errors.short_name }"
				/>
				<div class="invalid-feedback">{{errors.short_name}}</div>
			</div>
		</div>
		<div class="row form-row m-0 p-0">
			<div class="form-group col-auto my-1 input-min-width">
				<label>{{ Post.settingNames[Post.passportKeys.pipelineId] }}</label>
				<Field
					name="pipeline_id"
					as="select"
					class="form-control form-control-sm"
					:class="{ 'is-invalid': errors[Post.passportKeys.pipelineId] }"
					ref="pipeline_id_field"
				>
					<option value="" disabled selected>Натисніть щоб обрати</option>
					<option
						v-for="pip in pipelines()"
						:key="pip.id"
						:value="pip.id"
					>
						{{ pip.title }}
					</option>
				</Field>
				<div class="invalid-feedback">{{errors[Post.passportKeys.pipelineId]}}</div>
			</div>
		</div>
	</div>

	<!-- Organization -->
	<drop-down-spoiler>
		<template v-slot:title>
			<div class="row row-cols-3 justify-content-between">
				<div class="col-auto text-nowrap d-flex">
						<menu-icon name="organization" color="currentColor" edgeSize="20"/>&nbsp;
					<h6 class="fs-5 fw-bold text-nowrap m-0">
						{{ Post.settingNames[Post.passportKeys.orgId] }}
					</h6>
				</div>
			</div>
		</template>
		<template v-slot:body>
			<div :class="{
				'px-2': isDesktop,
				'px-1': isMobile,
			}">
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.orgId] }}</label>
						<Field
							name="org_id"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.org_id }"
							:disabled="accountStore.organization.role == 'secondary'"
							@change="
								setFieldValue('department_id', null);
								setFieldValue('sector_id', null);
								setFieldValue('pipeline_id', null);
								this.$refs.department_id_field.$el.disabled = true
								this.$refs.sector_id_field.$el.disabled = true
								this.$refs.pipeline_id_field.$el.disabled = true
							"
						>
							<option value="" disabled>Натисніть щоб обрати</option>
							<option
								v-for="org in organizations"
								:key="org._id"
								:value="org._id"
							>
								{{ org.title }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors.org_id}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ departmentTitle }}</label>
						<Field
							name="department_id"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.department_id }"
							ref="department_id_field"
							@change="setFieldValue('sector_id', null)"
						>
							<option value="" disabled selected>Натисніть щоб обрати</option>
							<option
								v-for="dep in departments()"
								:key="dep.id"
								:value="dep.id"
							>
								{{ dep.title }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors.department_id}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ sectorTitle }}</label>
						<Field
							name="sector_id"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.sector_id }"
							ref="sector_id_field"
						>
							<option value="" disabled selected>Натисніть щоб обрати</option>
							<option
								v-for="sec in departmnetSectors(values.department_id)"
								:key="sec.id"
								:value="sec.id"
							>
								{{ sec.title }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors.sector_id}}</div>
					</div>
				</div>
			</div>
		</template>
	</drop-down-spoiler>

	<!-- Lacation -->
	<drop-down-spoiler>
		<template v-slot:title>
			<h6 class="fs-5 fw-bold m-0">Місце розташування</h6>
		</template>
		<template v-slot:body>
			<div :class="{
				'px-2': isDesktop,
				'px-1': isMobile,
			}">
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.pipelineKm] }}</label>
						<Field
							:name="Post.passportKeys.pipelineKm"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.pipelineKm] }"
						/>
						<div class="invalid-feedback">{{errors[Post.passportKeys.pipelineKm]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.district] }}</label>
						<Field
							name="district"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.district }"
						/>
						<div class="invalid-feedback">{{errors.district}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.region] }}</label>
						<Field
							name="region"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.region }"
						/>
						<div class="invalid-feedback">{{errors.region}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div
						class="form-group col-auto my-1 input-min-width"
						:style="{ width: meta.initialValues.post_address ? meta.initialValues.post_address.length+'ch' : '15rem' }"
					>
						<label>{{ Post.settingNames[Post.passportKeys.postAddress] }}</label>
						<Field
							name="post_address"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.post_address }"
						/>
						<div class="invalid-feedback">{{errors.post_address}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.location] }}</label>
						<Field
							name="location.type"
							type="text"
							class="form-control form-control-sm"
							:disabled="true"
							:hidden="true"
						/>
						<Field
							name="location.coordinates"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.location }"
							:disabled="true"
						/>
						<div class="invalid-feedback">{{errors.location }}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.settlement] }}</label>
						<Field
							name="settlement"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.settlement }"
						/>
						<div class="invalid-feedback">{{errors.settlement}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.streetHouse] }}</label>
						<Field
							name="street_house"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.street_house }"
						/>
						<div class="invalid-feedback">{{errors.street_house}}</div>
					</div>
				</div>
			</div>
		</template>
	</drop-down-spoiler>

	<!-- Technical data -->
	<drop-down-spoiler>
		<template v-slot:title>
			<h6 class="fs-5 fw-bold m-0">Технічні відомості УКЗ</h6>
		</template>
		<template v-slot:body>
			<div :class="{
				'px-2': isDesktop,
				'px-1': isMobile,
			}">
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.controlType] }}</label>
						<Field
							name="control_type"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.control_type }"
						>
							<option value="" disabled selected>Натисніть щоб обрати</option>
							<option
								v-for="it in Object.values(Post.postControlType)"
								:key="it.key"
								:value="it.key"
							>
								{{ it.title }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors.control_type}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.brandModel] }}</label>
						<Field
							:name="Post.passportKeys.brandModel"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.brandModel] }"
						/>
						<div class="invalid-feedback">{{errors[Post.passportKeys.brandModel]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.manufacturer] }}</label>
						<Field
							:name="Post.passportKeys.manufacturer"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.manufacturer] }"
						/>
						<div class="invalid-feedback">{{ errors[Post.passportKeys.manufacturer] }}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.serialNumber] }}</label>
						<Field
							name="serial_number"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.serial_number }"
						/>
						<div class="invalid-feedback">{{errors.serial_number}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.produceDate] }}</label>
						<Field
							:name="Post.passportKeys.produceDate"
							type="date"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.produceDate] }"
							@change.stop="onChangeDate(Post.passportKeys.produceDate, $event.target.value)"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.produceDate] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<label class="row text-start mt-2 mx-0 my-auto">
						{{ Post.settingNames[Post.passportKeys.referenceElectrodePresent] }}
					</label>
					<div class="row mb-2 mt-0 ms-0 btn-group form-group input-min-width" style="width: 15rem;" role="group">
						<Field
							type="radio"
							class="btn-check"
							:class="{ 'is-invalid': errors[Post.passportKeys.referenceElectrodePresent] }"
							:name="Post.passportKeys.referenceElectrodePresent"
							:value="true"
							id="electrode-yes"
						/>
						<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="electrode-yes">так</label>

						<Field
							type="radio"
							class="btn-check"
							:class="{ 'is-invalid': errors[Post.passportKeys.referenceElectrodePresent] }"
							:name="Post.passportKeys.referenceElectrodePresent"
							:value="false"
							id="electrode-no"
						/>
						<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="electrode-no">ні</label>
					</div>
					<div class="invalid-feedback">
						{{ errors[Post.passportKeys.referenceElectrodePresent] }}
					</div>
				</div>
				<div class="row form-row">
					<label class="row text-start mt-2 mx-0 my-auto">
						{{ Post.settingNames[Post.passportKeys.commonProtectionDevicesPresent] }}
					</label>
					<div class="row mb-2 mt-0 ms-0 btn-group form-group input-min-width" style="width: 15rem;" role="group">
						<Field
							type="radio"
							class="btn-check"
							:class="{ 'is-invalid': errors[Post.passportKeys.commonProtectionDevicesPresent] }"
							:name="Post.passportKeys.commonProtectionDevicesPresent"
							:value="true"
							id="common_protection_devices-yes"
						/>
						<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="common_protection_devices-yes">так</label>

						<Field
							type="radio"
							class="btn-check"
							:class="{ 'is-invalid': errors[Post.passportKeys.commonProtectionDevicesPresent] }"
							:name="Post.passportKeys.commonProtectionDevicesPresent"
							:value="false"
							id="common_protection_devices-no"
						/>
						<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="common_protection_devices-no">ні</label>
					</div>
					<div class="invalid-feedback">
						{{ errors[Post.passportKeys.commonProtectionDevicesPresent] }}
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.commonProtectionDevicesType] }}</label>
						<Field
							:name="Post.passportKeys.commonProtectionDevicesType"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.commonProtectionDevicesType] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.commonProtectionDevicesType] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.anodeCable] }}</label>
						<Field
							:name="Post.passportKeys.anodeCable"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.anodeCable] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.anodeCable] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.pipeCable] }}</label>
						<Field
							:name="Post.passportKeys.pipeCable"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.pipeCable] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.pipeCable] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.anodeCroundingCableType] }}</label>
						<Field
							:name="Post.passportKeys.anodeCroundingCableType"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.anodeCroundingCableType] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.anodeCroundingCableType] }}
						</div>
					</div>
				</div>
			</div>
		</template>
	</drop-down-spoiler>

	<!-- Building passport -->
	<drop-down-spoiler>
		<template v-slot:title>
			<h6 class="fs-5 fw-bold m-0">Будівельний паспорт</h6>
		</template>
		<template v-slot:body>
			<div :class="{
				'px-2': isDesktop,
				'px-1': isMobile,
			}">
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.installationDate] }}</label>
						<Field
							:name="Post.passportKeys.installationDate"
							type="date"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.installationDate] }"
							@change.stop="onChangeDate(Post.passportKeys.installationDate, $event.target.value)"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.installationDate] }}
						</div>
					</div>
				</div>
				
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.projectOrganization] }}</label>
						<Field
							:name="Post.passportKeys.projectOrganization"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.projectOrganization] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.projectOrganization] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.installationOrganization] }}</label>
						<Field
							:name="Post.passportKeys.installationOrganization"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.installationOrganization] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.installationOrganization] }}
						</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.landUser] }}</label>
						<Field
							:name="Post.passportKeys.landUser"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[Post.passportKeys.landUser] }"
						/>
						<div class="invalid-feedback">{{errors[Post.passportKeys.landUser]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto my-1 input-min-width">
						<label>{{ Post.settingNames[Post.passportKeys.equipmentNumber] }}</label>
						<Field
							:name="Post.passportKeys.equipmentNumber"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[Post.passportKeys.equipmentNumber] }"
						/>
						<div class="invalid-feedback">
							{{ errors[Post.passportKeys.equipmentNumber] }}
						</div>
					</div>
				</div>
			</div>
		</template>
	</drop-down-spoiler>


	<div :class="{
		'px-2': isDesktop,
		'px-0': isMobile,
	}">
		<div class="row form-row m-0 p-0">
			<div class="form-group col-auto input-min-width mt-3">
				<aside class="fs-5 fw-bold m-0">
					{{ Post.settingNames[Post.passportKeys.relatedStations] }}
				</aside>
				<!-- Separate Field needed for normal load actual related stations to form -->
				<Field
					:name="Post.passportKeys.relatedStations"
					type="text"
					class="form-control form-control-sm"
					:class="{ 'is-invalid': errors[Post.passportKeys.relatedStations] }"
					hidden
				/>
				<!-- Separete Field end -->
				<FieldArray
					:name="Post.passportKeys.relatedStations"
					v-slot="{ fields, push, remove }"
				>
					<!-- {{ fields }} -->
					<aside v-if="fields.length == 0" class="my-1 text-body-secondary fst-italic">
						Список пустий.
					</aside>
					<fieldset
						class="py-0 my-0"
						v-for="(field, idx) in fields"
						:key="field.key"
					>
						<!-- {{ idx }} {{ field }} -->
						<div class="row align-items-center">
							<div class="col-10 pe-1 my-2">
								{{ stationsStore.station(field.value).name }}
							</div>
							<!-- Delete item button -->
							<div class="col-1 mx-1 px-0">
								<button
									type="button"
									class="btn btn-sm btn-outline-dark p-1 mx-1"
									style="line-height: 14px;"
									@click="remove(idx)"
								>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
										<path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
									</svg>
								</button>
							</div>
						</div> 
					</fieldset>

					<!-- Add related station button -->
					<div class="row align-items-center">
						<div class="col-8 pe-1 my-2">
							<Field
								name="pushedStation"
								as="select"
								class="form-control form-control-sm"
							>
								<option value="" disabled selected>Оберіть станцію</option>
								<option
									v-for="station in stations"
									:key="station.id"
									:value="station.id"
								>
									{{ station.title }}
								</option>
							</Field>
						</div>
						<div class="col-3 ms-4 px-0">
							<button
								type="button"
								class="btn btn-sm btn-outline-dark p-1 pe-2"
								style="line-height: 14px;"
								@click="push(values.pushedStation);"
								:disabled="
									values.pushedStation == undefined
									|| values.pushedStation == ''
									|| values[Post.passportKeys.relatedStations]?.includes(values.pushedStation)
								"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="currentColor"
									class=""
									viewBox="0 0 16 16"
									style="width: 1em; height: 1em;"
								>
									<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
								</svg>
								Додати
							</button>
						</div>
					</div>
				</FieldArray>
			</div>
		</div>
		
		<div class="row form-row m-0 p-0">
			<label class="row text-start mt-2 mx-0 my-auto">
				{{ Post.settingNames[Post.passportKeys.isActive] }}
			</label>
			<div class="row mb-2 mt-0 ms-0 btn-group form-group input-min-width" style="width: 15rem;" role="group">
				<Field
					type="radio"
					class="btn-check"
					:class="{ 'is-invalid': errors.is_active }"
					name="is_active"
					:value="true"
					id="is_active-yes"
				/>
				<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="is_active-yes">так</label>

				<Field
					type="radio"
					class="btn-check"
					:class="{ 'is-invalid': errors.is_active }"
					name="is_active"
					:value="false"
					id="is_active-no"
				/>
				<label class="col-6 mt-0 btn btn-sm btn-outline-secondary" for="is_active-no">ні</label>
			</div>
			<div class="invalid-feedback">{{errors.is_active}}</div>
		</div>
		<div class="row form-row m-0 p-0">
			<div
				class="form-group col-auto my-1 input-min-width"
				:style="{ width: formValues.notes ? formValues.notes.length+'ch' : '15rem' }"
			>
				<label>{{ Post.settingNames[Post.passportKeys.notes] }}</label>
				<Field
					name="notes"
					as="textarea"
					type="text"
					class="form-control form-control-sm"
					:class="{ 'is-invalid': errors.notes }"
				/>
				<div class="invalid-feedback">{{errors.notes}}</div>
			</div>
		</div>

		<div
			v-if="accountStore.account.role === 'admin'"
			class="row form-row m-0 p-0 my-3 form-text input-min-width"
		>
			<div class="row">
				<div class="col-auto me-auto">
					post ID
				</div>
				<div class="col-auto ms-auto">
					{{ post.passport.get(Post.passportKeys.id) }}
				</div>
			</div>
			<div class="row">
				<div class="col-auto me-auto">
					{{ Post.passportKeys.metricsId }}
				</div>
				<div class="col-auto ms-auto">
					{{ post.passport.get(Post.passportKeys.metricsId) }}
				</div>
			</div>
		</div>
	</div>

	<!-- <pre>{{ errors }} </pre>
	<pre>{{ values }} </pre> -->

	<div :class="{
		'px-0': isDesktop,
		'px-0': isMobile,
	}">
		<div class="row form-row m-0 p-0">
			<span class="form-text fst-italic">
				<p
					class="fs-5 text-center"
					:class="{'text-success': executionOk, 'text-danger': !executionOk}"
				>
					&nbsp;{{ executionResultMessage }}
				</p>
			</span>
		</div>
	</div>

	<div class="row form-row m-0 mt-1 mb-3 p-0"
		:class="{
			'px-0': isDesktop,
			'px-0': isMobile,
		}"
	>
		<div class="form-group col-auto m-0 p-0">
			&nbsp;
			<button
				type="button"
				class="btn btn-danger btn-sm"
				@click="showConfirmation=true"
				:disabled="!accountStore.permissions.includes('manage_posts')"
			>
				Видалити
			</button>
			<confirmation-popup
				v-model:show="showConfirmation"
				@confirm="deletePost();"
			>
				<template v-slot:body>
					<p>
						Ви дійсно хочете <b>видалити</b> КВП?<br>
						Після підтвердження <b class="text-danger">всі</b> дані, налаштування та паспорт КВП будут видалені.
					</p>
				</template>
			</confirmation-popup>
		</div>
		
		<div class="form-group col-auto ms-auto me-2">
			<button
				type="reset"
				class="btn btn-secondary btn-sm mx-2"
			>
				Відмінити
			</button>
		</div>
		<div class="form-group col-auto m-0 me-1 p-0">
			<button
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid"
			>
			<!-- @click="formMeta=meta" -->
				Зберегти
			</button>
		</div>
	</div>
<!-- </fieldset> -->
</Form>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore.js'
import { usePostsStore } from '@/stores/PostsStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import DropDownSpoiler from '@/components/DropDownSpoiler.vue'
import ConfirmationPopup from '../ConfirmationPopup.vue'
import MenuIcon from '@/components/Icons/MenuIcon.vue'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import {
	Form, Field, FieldArray, 
	//ErrorMessage,
} from 'vee-validate';
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';
import { PassportSchema } from "@/models/objectPrototype.js"
import { Post } from '@/models/post.js'
import { RESOURCE_NAMES,
	readResources,
	parseTimeDate, convertToApiTimeDate,
	deleteResourceItem
} from '@/api/api.js'
import { dateTimeToDateString } from '@/helpers'

export default {
	waitAfterDeleteSuccessMs: 3000,
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		DropDownSpoiler,
		ConfirmationPopup,
		MenuIcon,
		Form,
        Field,
		//ErrorMessage,
		FieldArray,
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()
		const stationsStore = useStationsStore()
		const { isDesktop, isMobile } = useSizeBreakpoint()

		return {
			Post,
			accountStore,
			postsStore,
			stationsStore,
			isDesktop,
			isMobile,
		}
	},

	data() {
		const schema = PassportSchema.shape({
			// 'p_1', 'p_2', 'p_3', 'p_4', 'p_5', 'p_6', 'p_7', 'p_8', 'p_9', 'p_10', 'p_11', 'p_12'
			control_type: Yup.string()
				.typeError(this.$options.wrongInputPromt),
				//.required(this.$options.requiredPromt),
		})

		return {
			//------------------ Form
			schema,
			formValues: {},
			//-----------------------
			//
			organizations: [],
			//  
			executionResultMessage: '',
			executionOk: null,
			//
			showConfirmation: false,
		}
	},

	async created() {
		if (this.stationsStore.stationsArray.length == 0) {
			// Read all stations
			await this.stationsStore.readStations()
		}

		// Read post passport
		await this.postsStore.readPassport((result) => {
			if (result) {
				const passport = Object.fromEntries(
					this.postsStore.post(this.postId).passport
				)
				
				// Enumerate all schema. Translate all datetime to form date
				for (const [key, value] of Object.entries(this.schema.fields)) {
					if (value.type == 'date' && passport[key]) {
						const timedate = parseTimeDate(passport[key])
						passport[key] = dateTimeToDateString(timedate)
					}
				}

				// Apply post passport to form
				this.formValues = passport;
				
				//console.log("Passport = ", this.formValues)
			} else {
				console.error("Can't read post passport!")
			}
		}, this.postId);

		// Read organization depend on user organization role
		if (this.accountStore.isPrimary) {
			// Read all organizations
			this.organizations = await readResources(
				RESOURCE_NAMES.organizations,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
			)
		} else {
			// Read only post organization
			//console.log("organization", this.accountStore.organization)
			this.organizations = [this.accountStore.organization,]
		}
	},

	mounted() {
	},

	methods: {
		// Delete date field if dat is cleared by button "Clear"
		onChangeDate(key, newDate) {
			if (newDate == "") {
				this.$refs.passportForm.setFieldValue(key, null)
			}
		},
		
		onCancel() {},

		onSubmit(values/*, meta*/) {
			
			//console.log("meta", meta)
			
			this.executionOk = null
			this.executionResultMessage = ''

			values[Post.passportKeys.updateBy] = this.accountStore.userId

			delete values[Post.passportKeys.location]
			delete values["pushedStation"]

			// Enumerate all schema.
			for (const [key, value] of Object.entries(this.schema.fields)) {
				// Translate all date to API datetime
				if (value.type == 'date' && values[key]) {
					values[key] = convertToApiTimeDate(values[key])
				}

				// Delete all empty strings
				if (value.type == 'string' && values[key]?.length == 0) {
					delete values[key]
				}

				// Delete all unefined fields
				if (values[key] === undefined) {
					delete values[key]
				}
			}
			// Make Post registered
			values[Post.passportKeys.isRegistered] = true

			// console.log("values", values)
				
			this.postsStore.updatePasport((result) => {
				if (result) {
					//console.log("Passport updates successfuly")
					this.executionOk = true
					this.executionResultMessage = 'Паспорт записано успішно'
				} else {
					//console.error("Passport update error")
					this.executionOk = false
					this.executionResultMessage = 'Помилка запису'
				}
			}, this.postId, values)		
        },

		deletePost() {
			this.executionOk = null
			this.executionResultMessage = ''

			// Delete organization
			deleteResourceItem(
				RESOURCE_NAMES.postPassports,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				this.post.passport.get(Post.passportKeys.id),
				this.post.passport.get("_etag")
			).then(() => {
				this.executionResultMessage = 'КВП видалено.'
				this.executionOk = true
				
				// Go to posts page after timeout
				setTimeout(
					() => {
						this.$router.push({ name: 'posts',})
					},
					this.$options.waitAfterDeleteSuccessMs
				);
			}).catch(err => {
				console.error("on delete account", err)
				this.executionResultMessage = 
					`КВП не видалено: сервер повернув помилку.`
				this.executionOk = false
			})
		},

		postOrg() {
			return this.post.passport.get(Post.passportKeys.org)
		},

		departments() {
			const org = this.postOrg()
			if (!org) {
				return []
			}

			const deps = org.departments
			if (!deps) {
				return []
			}

			return deps
		},

		departmnetSectors(depId) {
			if (!depId) {
				return []
			}

			const dep = this.departments().find(dep => dep.id == depId)

			if (!dep) {
				return []
			}

			return dep.sectors
		},

		pipelines() {
			const org = this.postOrg()
			if (!org) {
				return []
			}

			const pipelines = org.pipelines
			if (!pipelines) {
				return []
			}

			return pipelines
		},
	},

	computed: {
		post() { return this.postsStore.post(this.postId) },
		
		isFormEnabled() {
			return this.accountStore.permissions.includes('manage_posts')
		},
		
		departmentTitle() {
			return this.accountStore.organization.department_title ? 
				this.accountStore.organization.department_title :
				Post.settingNames[Post.passportKeys.departmentId]
		},

		sectorTitle() {
			return this.accountStore.organization.sector_title ?
				this.accountStore.organization.sector_title :
				Post.settingNames[Post.passportKeys.sectorId]
		},

		stations() {
			let stations = new Array()

			this.stationsStore.stationsArray.forEach(station => {
				// If current station is related
				if (this.formValues[Post.passportKeys.relatedStations]?.includes(station.id)) {
					return
				}

				stations.push({id: station.id, title: station.name})
			})

			return stations
		}
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

.input-min-width {
	min-width: 43ch; 
	max-width: 53ch;
	width: 100%;
}
</style>